
<div class="overlay" *ngIf="isLoading$ | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>

<div class="container-fluid pl-0">
  <div class="container-inner">

    
    <div class="header-container">
      <h2>Price</h2>

      <div class="search-container">
        <input
          type="text"
          [formControl]="searchInput"
          placeholder="Search..."
          class="form-control" />

        <span class="clear-icon"
              *ngIf="searchInput.value"
              (click)="clearSearch()">&times;</span>
      </div>
    </div>

    
    <div class="leads-table mb-3">
      <table mat-table [dataSource]="dataSource" class="mat-table">

        
        <ng-container matColumnDef="SNo">
          <th mat-header-cell *matHeaderCellDef> S.No </th>
          <td mat-cell *matCellDef="let row; let i = index">
            {{ pageIndex * pageSize + i + 1 }}
          </td>
        </ng-container>

        
        <ng-container matColumnDef="color_ind">
          <th mat-header-cell *matHeaderCellDef>Color Ind</th>
          <td mat-cell *matCellDef="let row">{{ row.color_ind }}</td>
        </ng-container>

        
        <ng-container matColumnDef="exsh_price">
          <th mat-header-cell *matHeaderCellDef>Ex-Showroom Price</th>
          <td mat-cell *matCellDef="let row">₹{{ row.exsh_price }}</td>
        </ng-container>

        
        <ng-container matColumnDef="for_cd">
          <th mat-header-cell *matHeaderCellDef>For Code</th>
          <td mat-cell *matCellDef="let row">{{ row.for_cd }}</td>
        </ng-container>

        
        <ng-container matColumnDef="from_date">
          <th mat-header-cell *matHeaderCellDef>From Date</th>
          <td mat-cell *matCellDef="let row">
            {{ row.from_date | date:'dd-MM-yyyy':'Asia/Kolkata' }}
          </td>
        </ng-container>

        
        <ng-container matColumnDef="sales_type">
          <th mat-header-cell *matHeaderCellDef>Sales Type</th>
          <td mat-cell *matCellDef="let row">{{ row.sales_type }}</td>
        </ng-container>

        
        <ng-container matColumnDef="variant_cd">
          <th mat-header-cell *matHeaderCellDef>Variant Code</th>
          <td mat-cell *matCellDef="let row">{{ row.variant_cd }}</td>
        </ng-container>

        
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

       
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="7" style="text-align:center;padding:20px">
            No data found!
          </td>
        </tr>
      </table>

    
      <mat-paginator
        [length]="totalCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 20]"
        showFirstLastButtons
        (page)="onPageChange($event)">
      </mat-paginator>
    </div>

  </div>
</div>
